export default __webpack_public_path__ + "static/media/bt1.16e9c6d8.jpg";